import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const CardWrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.semantic.background};
`

export const CardHeader = styled('div')`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
`

export const StepsList = styled('ol')<{ theme?: TTheme }>`
    margin: 0;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    color: ${({ theme }) => theme.colors.greys[800]};
`

export const StepItem = styled('li')`
    padding-left: 4px;
`
